import { testimonials } from '@/mocks/comic';

const principles = [
  { icon: 'ri-focus-3-line', title: '读得快', desc: '跳章、目录直达，让找内容不再费力。' },
  { icon: 'ri-treasure-map-line', title: '找得准', desc: '分卷结构清晰，跨卷跳转精准落位。' },
  { icon: 'ri-heart-line', title: '追得顺', desc: '进度随心跳跃，新章更新置顶提醒。' },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-block rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
              关于漫蛙漫画
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              为「追更」而生的阅读平台
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              漫蛙漫画相信，读漫画不该被「翻找」拖累。我们围绕跳章、目录跳转与分卷阅读打磨体验，
              让每一部长篇连载都能被高效、舒服地追完。无论你追的是几百话的热血长篇，
              还是每周更新的日常短篇，都能想读哪章读哪章。
            </p>

            <div className="mt-6 flex flex-col gap-3">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-3 rounded-2xl bg-background-50 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="font-heading text-xl font-bold text-foreground-950">读者口碑</h3>
            <p className="mt-2 text-sm text-foreground-600">来自真实追更用户的反馈</p>
            <div className="mt-5 space-y-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl bg-background-100 p-5">
                  <div className="flex items-center gap-1 text-secondary-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                    「{t.text}」
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-200 text-accent-900">
                      <i className="ri-user-fill" aria-hidden="true"></i>
                    </span>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}